import React from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer.jsx';

export default class CoveredVideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.props=props;
    this.state = {
      showCover: true,
      loading: true,
      playerInstance:null
    };
    this.handleReady = this.handleReady.bind(this);
    this.handleEnded = this.handleEnded.bind(this);
    this.handlePlay = this.handlePlay.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleError = this.handleError.bind(this);
  }
  handleReady(event) {
    console.log("READADA");
    this.setState(
      {
        playerInstance: event.target,
        loading:false
      }
    );
  }
  handleEnded(event) {
    this.setState(
      {
        showCover: true
      }
    );
    if(this.props.onEnded) {
      this.props.onEnded(event);
    }
  }
  handlePlay(event) {
    this.setState(
      {
        showCover: false,
        loading: false
      }
    );
    if(this.props.onPlay) {
      this.props.onPlay(event);
    }
  }
  handleClick() {
    if(this.state.playerInstance) {
      if(this.state.playerInstance.playVideo) {
        this.state.playerInstance.playVideo();
        this.setState({ loading:true });  
      } else if(this.state.playerInstance.play) {
        this.state.playerInstance.play();
        this.setState({ loading:true });
      }
      
    }
  }
  handlePause(event) {
    if(this.props.onPause) {
      this.props.onPause(event);
    }
  }
  handleError(event) {
    if(this.props.onError) {
      this.props.onError(event);
    }
  }
  getVideoPlayer() {
    let vidplayerprops = {
      onCanPlay: this.handleReady,
      onPlay: this.handlePlay,
      onEnded: this.handleEnded,
      onPause: this.handlePause,
      onError: this.handleError,
    };
    if(this.props.srcMP4) {
      vidplayerprops.srcMP4 = this.props.srcMP4;         
    } 
    if(this.props.srcWEBM) {
      vidplayerprops.srcWEBM = this.props.srcWEBM;
    }
    if(this.props.youtubeId) {
      vidplayerprops.youtubeId = this.props.youtubeId;
    }
    if(this.props.slug) {
      vidplayerprops.slug = this.props.slug;
    }
    return (<VideoPlayer {...vidplayerprops} />);
  }
  
  render() {
    return (
      <div style={{position: "relative", width:"100%", height:0, paddingBottom: "56.25%"}}>
        <div style={{position: "absolute", left:"10px", bottom:"10px", visibility: this.state.showCover?"visible":"hidden", zIndex:3}} onClick={this.handleClick}>
          <a className="btn-floating btn-large waves-effect waves-light teal">
            <i className="mdi-av-play-arrow"></i>
          </a>
        </div>
        <div style={{position: "absolute", left:0, top:0, width:"100%", height:"100%", visibility: this.state.loading?"visible":"hidden", zIndex:2}} onClick={this.handleClick}>
          <div className="center-align" style={{position:"relative", top:"calc(50% - 32px)"}}>
            <div className="preloader-wrapper big active">
              <div className="spinner-layer">
                <div className="circle-clipper left">
                  <div className="circle"></div>
                </div><div className="gap-patch">
                  <div className="circle"></div>
                </div><div className="circle-clipper right">
                  <div className="circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{position: "absolute", width:"100%", height:"100%", left:0, top:0, zIndex:1, visibility: this.state.showCover?"visible":"hidden"}}>
          {this.props.children}
        </div>
        <div style={{position: "absolute", width:"100%", height:"100%", left:0, top:0, zIndex:0}}>
          {this.getVideoPlayer()}
        </div>  
      </div>
    );
  }
}


CoveredVideoPlayer.propTypes = {
    onEnded: React.PropTypes.func,
    onCanPlay: React.PropTypes.func,
    onPlay: React.PropTypes.func,
    onPause: React.PropTypes.func,
    onError: React.PropTypes.func,
    youtubeId: React.PropTypes.string,
    srcMP4: React.PropTypes.string,
    srcWEBM: React.PropTypes.string,
    slug: React.PropTypes.string
};


// WEBPACK FOOTER //
// ./src/js/components/CoveredVideoPlayer/CoveredVideoPlayer.jsx